import { Typography } from "@mui/material";
import React from "react";
import { useParams } from "react-router-dom";
import PageLayout from "../components/common/page-layout";
import IngestionTestRunDetail from "../components/ingestion-test-runs/ingestion-test-run-detail";
import { RequireAuth } from "../hooks/use-auth";

/**
 * Debug pane for one ingestion test run, addressed by its id in the route.
 * Shows the run's lifecycle timeline, dispatch/echoed context, decision plan,
 * exemplar marker, and cost — read strictly by id.
 */
const IngestionTestRunDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  return (
    <RequireAuth>
      <PageLayout
        subtitle="New document-extraction pipeline"
        title="Ingestion test run"
      >
        {id === undefined ? (
          <Typography>No run id in the route.</Typography>
        ) : (
          <IngestionTestRunDetail runId={id} />
        )}
      </PageLayout>
    </RequireAuth>
  );
};

export default IngestionTestRunDetailPage;
